<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Overview from "@/view/components/subscriber/profile/Overview2.vue";
import ProfileForm from "@/view/components/subscriber/profile/ProfileForm.vue";
import Notes from "@/view/components/subscriber/profile/Notes.vue";
import CardList from "@/view/components/subscriber/profile/CardsList.vue";
import { getSubcriberProfile, getGuestProfile, deletedCustomer } from "@/api/subscribers";
import { setLocation } from "@/utils";
export default {
  name: "subscriber-profile",
  components: {
    Overview,
    ProfileForm,
    Notes,
    CardList
  },
  data() {
    return {
      loading: true,
      loadingCircle: false,
      overlayText: "Loading ...",
      active_tab: 0,
      item: {},
      location_id: null,
      subscriber: null,
      dialogDelete: false,
      dialogMsg: "Are you sure you want to delete this selected user?",
      error: false,
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Profile" }]);
    this.goLoad()
    this.$store.commit("setLocationVisibile", true);
    this.loading = true;
    setLocation(null);
    if (this.$route.path.includes('guest/profile')) {
      if (this.$route.params.id) {
        this.$store.commit("setProfileId", this.$route.params.id.trim());
        this.subscriber = await getGuestProfile(this.$route.params.id.trim(), this.$route.params.pos_id, this.$route.params.hashid);
        // var guest_name = this.subscriber.profile.first_name;
        // this.subscriber.profile.first_name = guest_name.split(' ').slice(0, -1).join(' ');
        // this.subscriber.profile.last_name = guest_name.split(' ').slice(-1).join(' ');
        this.$store.commit("setSubscriberProfile", this.subscriber);
      }
    }
    else {
      if (this.$route.params.id) {
        this.$store.commit("setProfileId", this.$route.params.id.trim());
        this.subscriber = await getSubcriberProfile(this.$route.params.id.trim(), this.$route.params.pos_id, this.$route.params.hashid);
        this.$store.commit("setSubscriberProfile", this.subscriber);
      }
    }
    this.doneLoad()
  },
  computed: {
    getProfile() {
      return this.$store.getters["getSubcriberProfile"];
    }
  },
  watch: {
    getProfile(newVal) {
      this.item = newVal;
      let i = 0
      let new_payment_tokens = newVal.payment_tokens.map(v => ({...v, customeId: i++})) // this is for unique key in TransactionsTable.vue
      this.item.payment_tokens = new_payment_tokens
      this.loading = false;
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'subscribers' })
    },
    removeItems() {
      
        this.dialogMsg = "Are you sure you want to delete this selected user?";
        this.error = false;      
        this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    async removeItemsConfirm() {
      this.dialogDelete = false;
      this.removeLoading = true;
      this.loading =  true
      let pk = this.$route.params.id.trim()
      let pos_id = this.$route.params.pos_id
      let hash_id =  this.$route.params.hashid      
      let response = await deletedCustomer(pk, hash_id, pos_id);
       
      setTimeout(() => { 
        this.loading =  false
        this.removeLoading = false;
      }, 2000);
      this.$router.push({ path: '/subscribers' })      
    },
    goLoad(){
      this.loading = true
      this.loadingCircle = true
      this.overlayText = "Loading ...."
    },
    doneLoad(){
      this.loading = false
    },
  }
};
</script>
<style scoped>
.basil {
  background-color: #eef0f8 !important;
}
.basil--text {
  color: #356859 !important;
}
</style>

<template>
  <v-app class="bg-transparent">
    <v-main>
      <v-overlay :value="loading">
          <div class="text-center">
            <p>{{overlayText}}</p>
            <v-progress-circular v-if="loadingCircle" indeterminate size="30"></v-progress-circular>
          </div>
        </v-overlay>
      <v-card color="basil" flat>
        <div class="d-flex align-items-center justify-space-between">
          <v-btn color="primary" small @click="back" class="ml-5">
            Back
          </v-btn>
          <v-btn class="mr-4 ml-4" @click="removeItems()" depressed tile small >
            <v-icon left> mdi-delete </v-icon>
            Delete
          </v-btn>
        </div>
        <v-dialog v-model="dialogDelete" max-width="510px">
        <v-card>
          <v-card-title class="headline">{{ dialogMsg }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!error" color="blue darken-1" text @click="closeDelete"
              >Cancel</v-btn
            >
            <v-btn
              v-if="!error"
              color="blue darken-1"
              text
              @click="removeItemsConfirm"
              >OK</v-btn
            >

            <v-btn v-if="error" color="primary" @click="closeDelete"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <v-tabs
          v-model="active_tab"
          background-color="transparent"
          color="basil"
          grow
          left
        >
          <v-tab @click="tabIndex = 0">Overview</v-tab>
          <v-tab @click="tabIndex = 1">Basic Information</v-tab>
          <v-tab @click="tabIndex = 2">Notes</v-tab>
          <v-tab @click="tabIndex = 3">Cards</v-tab>
          <v-tab-item :key="0">
            <v-card color="basil" flat>
              <v-card-text
                ><overview v-if="!loading" :item="item"></overview
              ></v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="1">
            <v-card color="basil" flat>
              <v-card-text
                ><ProfileForm v-if="!loading" :item="item"></ProfileForm
              ></v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="2">
            <v-card color="basil" flat>
              <v-card-text
                ><Notes v-if="!loading" :item="item"></Notes
              ></v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="3">
            <v-card color="basil" flat>
              <v-card-text
                ><CardList v-if="!loading" :item="item"></CardList
              ></v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-main>
  </v-app>
</template>
